<template>
    <div class='p-d-flex p-jc-center p-px-4 p-pb-2 p-pt-3' style="background:#f9f9f9; border:1px solid #d9d9d9;">
        <div class="p-d-flex p-jc-start p-ai-center p-flex-column">
            <h5 class="p-my-0 text-muted">SU BÚSQUEDA POR FILTROS NO PRODUJO RESULTADOS</h5>
            <Button v-if="tipo == 'cursos'" label="QUITAR FILTROS" @click="quitar_filtro_cursos" icon="pi pi-times" class="p-button-text p-button-danger"></Button>
            <Button v-else label="QUITAR FILTROS" @click="quitar_filtro_rutas" icon="pi pi-times" class="p-button-text p-button-danger"></Button>
        </div>
    </div>
</template>

<script>
import { string } from 'yargs';

export default {
    name: 'BusquedaNoResultado',
    props : {
        tipo : {
            type : string
        }
    },
    methods : {
        quitar_filtro_rutas : function(){
            this.$emit('quitar_filtro_rutas');
        },
        quitar_filtro_cursos : function(){
            this.$emit('quitar_filtro_cursos');
        }
    }
}
</script>